export const CONST = {
  //BACKEND_URL: 'http://localhost:6366/api/v1'
  // BACKEND_URL: 'https://lead-backend.vercel.app/api/v1'
   BACKEND_URL: 'https://oldleads.comfygen.in/api/v1'
};
